import React, { useState, useRef } from "react";
import styles from './.FilterBoxComponents.module.css';
import Papa from 'papaparse'; // Highly recommended: npm install papaparse

const LinkedInUrlFilter = ({ searchSize, contactLinkedInUrls, setContactLinkedInUrls }) => {
    const [error, setError] = useState("");
    const fileInputRef = useRef(null);

    const cleanUrl = (url) => {
        if (!url || typeof url !== 'string') return "";
        return url
            .trim()
            .toLowerCase()
            .replace(/^(https?:\/\/)?(www\.)?/, "") // Remove http, https, and www
            .replace(/\/$/, "");                   // Remove trailing slash
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Reset error and states
        setError("");

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                const headers = results.meta.fields;
                
                // 1. Find acceptable permutation of "LinkedIn URL"
                const targetHeader = headers.find(h => 
                    /(linkedin|profile)[_\s-]?url/i.test(h.trim())
                );

                if (!targetHeader) {
                    // 2. UPDATED: Error message
                    setError("Error: No 'LinkedIn URL' or 'Profile URL' column found.");
                    return;
                }

                // 2. Limit rows to searchSize (not including header)
                if (results.data.length > searchSize) {
                    setError(`Error: Maximum ${searchSize.toLocaleString()} rows allowed.`);
                    return;
                }

                // 3. Extract and clean the URLs
                const cleanedList = results.data
                    .map(row => cleanUrl(row[targetHeader]))
                    .filter(url => url !== ""); // Remove empty strings

                setContactLinkedInUrls(cleanedList);
            },
            error: (err) => {
                setError("Error parsing the CSV file.");
                console.error(err);
            }
        });
    };

    const handleClear = () => {
        setContactLinkedInUrls([]);
        if (fileInputRef.current) fileInputRef.current.value = "";
        setError("");
    };

    return (
        <div className={styles.accordionContent}>
            <div className={styles.uploadSection}>
                <label className={styles.filterLabel}>Upload LinkedIn CSV</label>
                <input 
                    type="file" 
                    ref={fileInputRef}
                    accept=".csv" 
                    onChange={handleFileUpload}
                    className={styles.fileInput}
                />
                <p className={styles.helpText}>
                    Must have a "LinkedIn URL" or "Profile URL" column (Max {searchSize.toLocaleString()} rows).
                </p>

                {error && <div className={styles.errorText}>{error}</div>}
                
                {contactLinkedInUrls.length > 0 && (
                    <div className={styles.successContainer}>
                        <span className={styles.successText}>
                            {contactLinkedInUrls.length} URLs Loaded
                        </span>
                        <button onClick={handleClear} className={styles.clearButton}>
                            Clear
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default LinkedInUrlFilter;